// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"617":"d7eeaac4","678":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"589":"2eedc11470a2c1d6a8e1","617":"f18387f4785cd6c04042","678":"fe90a898cd1ac216e1be"}[chunkId] + ".js";
};